import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import HeroSection from './components/HeroSection'
import AppDetails from './components/AppDetails'
import ComparisonTable from './components/ComparisonTable'
import CTASection from './components/CTASection'

const Apps = () => {
  const location = useLocation()

  useEffect(() => {
    // Scroll to specific app section if hash is present
    if (location.hash) {
      const element = document.querySelector(location.hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }, [location.hash])

  return (
    <div className="min-h-screen">
      <HeroSection />
      <AppDetails />
      <ComparisonTable />
      <CTASection />
    </div>
  )
}

export default Apps
